/**
 * Created by dafre on 5/12/2017.
 */

export class LineVertex {

  public PositionBuffer: any[];
  public ColorBuffer: any[];
  public NormalBuffer: any[];
  public IndexBuffer: any[];
  public TangentBuffer: any[];
  public BiTangentBuffer: any[];
  public TextureCoordBuffer: any[];

}



// WEBPACK FOOTER //
// ./src/app/lineVertex.ts